import { type BranchData } from '@/lib/branch/types'

export function readBranchLink() {
  return new Promise<BranchData>((resolve, reject) => {
    window.branch?.data((err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve(data)
      }
    })
  })
}
